import { useEffect } from "react";

import { TenantDto } from "@/core/api/generated/v1";
import { fetchCurrentTenant } from "@/store/tenants/slice";

import { useAuthenticationInfo } from "../../auth/useAuthenticationInfo";
import { useAppSelector, useAppThunkDispatch } from "../../redux";
import { useCurrentTenantInfoV2 } from "./useCurrentTenantInfoV2";

/** Returns currently resolved tenant. */
export const useCurrentTenant = (props?: {
  isRefetch?: boolean;
  isSkipFetch?: boolean;
}): Nil<TenantDto> => {
  const dispatch = useAppThunkDispatch();

  const authenticationInfo = useAuthenticationInfo();
  const tenantInfo = useCurrentTenantInfoV2();
  const currentTenant = useAppSelector((x) => x.tenants.currentTenant);

  useEffect(() => {
    if (
      authenticationInfo.isAuthenticated &&
      !currentTenant &&
      tenantInfo.tenantInfo?.identifier &&
      !props?.isSkipFetch
    ) {
      dispatch(fetchCurrentTenant({ ...props }));
    }
  }, [authenticationInfo, tenantInfo, props?.isSkipFetch]);

  return currentTenant;
};
